import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

class MainWrapper extends PureComponent {
  render() {
    const { theme: { className }, sidebar: { collapse }, children } = this.props;
    return (
      <div className={className}>
        <div className={collapse ? 'wrapper wrapper--full-width' : 'wrapper'}>
          {children}
        </div>
      </div>
    )
  }
}

export default connect(state => {
  return {theme: state.theme,
          sidebar: state.sidebar}
})(MainWrapper);



// WEBPACK FOOTER //
// ./src/app/MainWrapper.js